import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Inmediatamente después del pago recibís un email con el link de descarga de todos los PDFs. El acceso es inmediato, 24/7. Si no llega el email en 10 minutos, revisá la carpeta de spam o escribinos.'
}, {
  question: '2 — ¿Sirve para entrenadores independientes o solo para gyms?',
  answer: 'Está diseñado para ambos. Da igual si sos profe que da clases en una plaza, en un garage, en un gym alquilado o si tenés tu propio local. El sistema funciona con 3 alumnos o con 30.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'Los PDFs no son editables para proteger el contenido. Pero cada clase y plantilla está diseñada para ser usada tal cual o adaptada mentalmente en segundos. El sistema 3-1-1 está pensado para que lo leas 5 minutos antes y ejecutes sin cambiar nada.'
}, {
  question: '4 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos sin costo extra en las dos opciones. La diferencia entre la Opción 1 y la Opción 2 es que la segunda incluye además el Método Gym Lleno 2026™ (sistema de negocio completo).'
}, {
  question: '5 — ¿Sirve si soy profe nuevo con poca experiencia?',
  answer: 'Es ideal para profes nuevos. El sistema está diseñado para que no necesites improvisar nada. Cada clase tiene el objetivo, el desarrollo completo y el cierre. Lo leés, lo ejecutás. No necesitás años de experiencia para dar una clase de nivel profesional.'
}, {
  question: '6 — ¿Sirve para alumnos de todas las edades?',
  answer: 'Sí. El sistema cubre desde principiantes absolutos hasta alumnos avanzados. El Bono 1 resuelve específicamente cómo dar una clase para múltiples niveles al mismo tiempo con el Método 3 Carriles.'
}, {
  question: '7 — ¿Qué pasa si tengo alumnos de distintos niveles juntos?',
  answer: 'Eso es exactamente para lo que fue creado el Bono 1: Kit Clase Mixta Perfecta. Con el Método 3 Carriles, todos los alumnos trabajan el mismo objetivo del día, cada uno en su nivel. Sin duplicar la clase. Sin que nadie se aburra ni se pierda.'
}, {
  question: '8 — ¿Qué diferencia tiene con otros materiales de boxeo?',
  answer: 'La mayoría de los materiales de boxeo son técnicos: te explican cómo hacer los golpes. Este sistema es operativo: te dice exactamente qué hacer en cada minuto de cada clase, durante todo el año, con planillas de progreso, tests, eventos internos y guanteo estructurado. No es un libro de técnica. Es el GPS de tu gym.'
}, {
  question: '9 — ¿Por qué elegir el Combo con Método Gym Lleno?',
  answer: 'Porque tener las mejores clases del mundo no sirve de nada si el gym está medio vacío o cobrás menos de lo que merecés. El Método Gym Lleno agrega el sistema de negocio: precios, membresías, captación, retención y marketing. Es para el entrenador que quiere vivir del boxeo, no solo sobrevivir de él.'
}, {
  question: '10 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días de garantía total sin preguntas. Si abrís los tomos, los revisás y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios complicados. Un mensaje y listo. La tasa de devoluciones es menor al 1%.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-172">
      <div className="max-w-3xl mx-auto" data-id="element-173">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-174">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-175">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#F97316] bg-[#0d0700]' : 'border-[#F97316]/20 bg-black'}`} data-id="element-176">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-177">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-178">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#F97316] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-179">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-180">
                  <div className="h-px bg-[#F97316]/20 mb-4" data-id="element-181" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-182">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}